 <!-- 平台公告管理 -->
<template>
  <div class="content" >
    <!-- search start -->
    <div class="search-area">
      <el-row :gutter="24" style="height:34px">
        <el-col :span="6">
          <div class="search-area-div">关键字</div>
          <el-input size="mini" class="ipt-sty" v-model="page.keywordSearch" placeholder="请输入公告标题、内容、摘要" filterable> </el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">公告状态</div>
          <el-select size="mini" class="ipt-sty" v-model="page.noticeState" placeholder="请选择" filterable>
            <el-option v-for="item in noticeStatus" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">公告类型</div>
          <el-select size="mini" class="ipt-sty" v-model="page.noticeType" placeholder="请选择" filterable>
            <el-option v-for="item in getCodeListByKey('平台公告类型')" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button
              size="mini"
              type="text"
              @click="showMore = !showMore"
              :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            >
              {{ showMore ? "收起筛选" : "更多筛选" }}
            </el-button>
          <el-button size="mini" type="info" @click="getList(true)">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="24" style="height:34px" class="mt15" v-show="showMore">
        
        <el-col :span="6">
          <div class="search-area-div">通知公司</div>
          <el-select size="mini" class="ipt-sty" v-model="page.tenantGuid" filterable placeholder="请选择" >
            <el-option v-for="item in sendTenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">反馈要求</div>
          <el-select size="mini" class="ipt-sty" v-model="page.feedbackRequest" placeholder="请选择" filterable>
            <el-option v-for="item in feedbackStatus" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">是否强提醒</div>
          <el-select size="mini" class="ipt-sty" v-model="page.isStrongRemind" placeholder="请选择" filterable>
            <el-option v-for="item in getCodeListByKey('是否')" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        
      </el-row>
      <el-row :gutter="24" style="height:34px" class="mt15" v-show="showMore">
        
        <el-col :span="6">
          <div class="search-area-div">发布日期</div>
          <el-date-picker
            size="mini"
            v-model="publishTime"
            type="daterange"
            class="ipt-sty"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="截止日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-col>
        
      </el-row>
    </div>
    <!-- search end -->

    <!-- table start -->
    <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px'">
      <div class="button-area">
        <el-button size="mini" type="info" @click="addAdv" 
          >发布公告</el-button
        >
      </div>
      <el-table :height="tableHeight" :data="tableData" stripe border tooltip-effect="light" style="width: 100%" v-loading="fullscreenLoading">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="noticeTitle"
          label="公告标题"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="220"
        >
          <template slot-scope="scope">{{ scope.row.noticeTitle || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="noticeType"
          label="公告类型"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="96"
        >
          <template slot-scope="scope">{{ scope.row.noticeType | commonFilterName('平台公告类型') }}</template>
        </el-table-column>
        <el-table-column
          prop="tenantName"
          label="通知公司"
          show-overflow-tooltip
          header-align="center"
          align="left"
          min-width="106"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.publishObjectType=='1'">所有服务人员</span>
            <span v-else>{{ scope.row.tenantName | tenantNameFilter}}</span>
            <!-- {{ scope.row.publishObjectType=='1'? '所有服务人员' :`${scope.row.tenantName[0]}`  }} -->
          </template>
        </el-table-column>
        <el-table-column
          prop="feedbackRequest"
          label="反馈要求"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="96"
        >
          <template slot-scope="scope">{{ scope.row.feedbackRequest |  feedbackStatusType }}</template>
        </el-table-column>
        <el-table-column
          width="96"
          show-overflow-tooltip
          prop="notifyUserNum"
          label="通知总人数"
          header-align="center"
          align="left"
        >
        <template slot-scope="scope">{{ scope.row.notifyUserNum }}</template>
        </el-table-column>
        
        <el-table-column
          prop="readUserNum"
          width="96"
          label="阅读总人数"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">{{ scope.row.readUserNum  }}</template>
        </el-table-column>
        <el-table-column
          prop="confirmUserNum"
          width="96"
          label="确认总人数"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">{{ scope.row.confirmUserNum  }}</template>
        </el-table-column>
        <el-table-column
          prop="signUserNum"
          label="签字总人数"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="96"
        >
          <template slot-scope="scope">{{ scope.row.signUserNum  }}</template>
        </el-table-column>
        <el-table-column
          prop="isStrongRemind"
          label="登录后强提醒"
          show-overflow-tooltip
          header-align="center"
          align="center"
          width="96"
        >
          <template slot-scope="scope" class="import-state-success">
            <span v-show="scope.row.isStrongRemind=='Y'" class="state-class">是</span>
            <span v-show="scope.row.isStrongRemind=='N'" class="state-class-grey">否</span>
            
          </template>
        </el-table-column>
        <el-table-column
          prop="noticeState"
          label="公告状态"
          show-overflow-tooltip
          header-align="center"
          align="center"
          width="96"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.noticeState=='2'" class="state-class">
              {{ scope.row.noticeState | noticeStateType }}
            </span>
            <span v-else :class="scope.row.noticeState=='1'?'state-class-org':'state-class-grey' ">
              {{ scope.row.noticeState | noticeStateType }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          sortable
          label="发布时间"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="190"
        >
          <template slot-scope="scope">{{ scope.row.publishDate | getTimeDate }}</template>
        </el-table-column>
        <el-table-column
          prop="updateTime"
          sortable
          label="操作时间"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="190"
        >
          <template slot-scope="scope">{{ scope.row.updateTime | getTimeDate }}</template>
        </el-table-column>
        <el-table-column
          prop="taskTotal"
          label="操作人"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="96"
        >
          <template slot-scope="scope">{{ scope.row.updateUserName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="bank" min-width="190" label="操作" header-align="center" align="center" fixed="right">
          <template slot-scope="scope">
            <div>
              <a class="txt-color" v-if="scope.row.createUserId===userGuid && scope.row.noticeState === '1'" @click="changeState(scope.row.guid,'4')">作废 | </a>
              <a class="txt-color" v-if="scope.row.createUserId===userGuid && scope.row.noticeState === '2'" @click="changeState(scope.row.guid,'3')">撤回 | </a>
              <!-- <a class="txt-color" v-if="scope.row.createUserId===userGuid && (scope.row.noticeState === '3'||scope.row.noticeState === '4')" @click="toEdit(scope.row)">重新发布 | </a> -->
              <a class="txt-color" v-if="scope.row.createUserId===userGuid && scope.row.noticeState === '1'" @click="toEdit(scope.row)">编辑 | </a>
              <a class="txt-color" @click="toEdit(scope.row,true)">详情 | </a>
              <a class="txt-color" v-if="scope.row.noticeState === '2'||scope.row.noticeState === '3'" @click="readConfig(scope.row)">阅读情况 | </a>
              <a class="txt-color" v-if="scope.row.createUserId===userGuid && (scope.row.noticeState === '3'||scope.row.noticeState === '4')" @click="delAnnounce(scope.row.guid)" >删除 | </a >
              <a class="txt-color"  @click="toCopy(scope.row)" >复制</a >
              
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <!-- table end -->
    <!-- start of dialog-阅读情况 -->
    <el-dialog class="read-box" title="查看阅读情况" custom-class="configure-fields" :visible.sync="readDialog">
      <div class="search-area read-dialog">
        <el-row :gutter="24">
          <el-col :span="6">
            <div class="search-area-div">阅读人</div>
            <el-input size="mini" v-model="page3.staffName" placeholder="请输入" class="ipt-sty" />
          </el-col>
          <!-- <el-col :span="6" >
            <div class="search-area-div">阅读状态</div>
            <el-select size="mini" class="ipt-sty" v-model="page3.isRead" placeholder="请选择" filterable>
            <el-option v-for="item in readStatus" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
          </el-col> -->
          <el-col :span="6">
            <div class="search-area-div">确认状态</div>
            <el-select size="mini" class="ipt-sty" v-model="page3.isConfirm" placeholder="请选择" filterable>
              <el-option v-for="item in confirmStatus" :key="item.value" :label="item.text" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">签字状态</div>
            <el-select size="mini" class="ipt-sty" v-model="page3.isSign" placeholder="请选择" filterable>
              <el-option v-for="item in signStatus" :key="item.value" :label="item.text" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          
          <el-col :span="6"  class="search-btn-box">
            <el-button size="mini" type="info" @click="getReadInfo()">搜索</el-button>
            <el-button size="mini" type="danger" @click="emptyReadSearch">清空</el-button>
          </el-col>
          
        </el-row>
        <!-- <el-row :gutter="24">
          <el-col :span="6">
            <div class="search-area-div">签字状态</div>
            <el-select size="mini" class="ipt-sty" v-model="page3.isSign" placeholder="请选择" filterable>
            <el-option v-for="item in signStatus" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
          </el-col>
        </el-row> -->
        <el-row :gutter="24" style="margin-bottom: -16px;">
          <!-- <el-col :span="8"  class="feedback-box">
            
          </el-col> -->
          <el-col :span="20"  class="feedback-box">
            公告标题：{{ noticeTitle}} 
            <span style="margin-left: 24px;"></span>
            反馈要求：{{ feedbackRequest |  feedbackStatusType }}
          </el-col>
          <el-col :span="4"  class="search-btn-box">
            <el-button size="mini" type="info" @click="report">导出明细</el-button>
            
          </el-col>
        </el-row>
      </div>
      <el-dialog
        width="30%"
        title="签字图片"
        :visible.sync="innerVisible"
        append-to-body>
        <img style="width:100%" :src="innerUrl" alt="">
      </el-dialog>
      <el-table :data="readList" height="365" style="width: 100%;margin-bottom: 10px; "  border tooltip-effect="light" stripe v-loading="loading">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="staffName" label="阅读人" header-align="center" align="center" min-width="120"> </el-table-column>
        <el-table-column prop="organisationNames" show-overflow-tooltip label="所在部门" header-align="center" min-width="160" align="center">
          
        </el-table-column>
        <!-- v-if="feedbackRequest=='1'" -->
        <el-table-column  prop="isRead" label="阅读状态" header-align="center" align="center"> 
          
          <template slot-scope="scope">
            <span  :class="scope.row.isRead=='Y'?'state-class':'state-class-grey' ">
              {{ scope.row.isRead =='Y'?'已读':'未读' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column  prop="readTime" label="阅读时间" header-align="center" align="center" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.readTime | getTimeDate }}</span>
          </template>
        </el-table-column>
        <!-- v-if="feedbackRequest=='2'" -->
        <el-table-column  prop="isConfirm" label="确认状态" header-align="center" align="center">
          
          <template slot-scope="scope">
            <span  :class="scope.row.isConfirm=='Y'?'state-class':'state-class-grey' ">
              {{ scope.row.isConfirm =='Y'?'已确认':'未确认' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column  prop="confirmTime" label="确认时间" header-align="center" align="center" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.confirmTime | getTimeDate }}</span>
          </template>
        </el-table-column>
        <!-- v-if="feedbackRequest=='3'" -->
        <el-table-column  prop="isSign" label="签字状态" header-align="center" align="center">
          
          <template slot-scope="scope">
            <span  :class="scope.row.isSign=='Y'?'state-class':'state-class-grey' ">
              {{ scope.row.isSign =='Y'?'已签字':'未签字' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column  prop="signTime" label="签字时间" header-align="center" align="center" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.signTime | getTimeDate }}</span>
          </template>
        </el-table-column>
        <el-table-column  prop="signTime" label="签字图片" header-align="center" align="center" width="160">
          <template slot-scope="scope">
            <img style="height:23px;vertical-align:middle" v-if="scope.row.signUrl" :src="scope.row.signUrl[0].path" alt="" @click="onPreview(scope.row.signUrl[0])">
            <!-- <span>{{ scope.row.signTime | getTimeDate }}</span> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange3"
        @current-change="handleCurrentChange3"
        :page-sizes="[10, 20, 50, 100, 200]"
        :current-page="page3.pageIndex"
        :page-size="page3.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page3.totalRows"
      >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
          <!-- <el-button size="mini" plain @click="readDialog = false">取 消</el-button> -->
          <el-button size="mini" type="info" @click="readDialog = false" >确 定</el-button>
        </span>
    </el-dialog>
    <!-- end of dialog-阅读情况 -->
    
  </div>
</template>

<script>
export default {
  data() {
    let userinfo = JSON.parse(localStorage.userInfo);
    return {
      userinfo: userinfo,
      showMore: false,
      tableHeight: window.innerHeight - 263,
      contentMainHeight: window.innerHeight - 200,
      fullscreenLoading: false,
      showMore:false,//搜索框展示更多
      userGuid:'',//当前登陆人
      tableData: [],
      sendTenantList: [],//通知公司列表
      publishTime:[],//发布时间
      feedbackRequest:'',//反馈要求
      noticeTitle:'',//公告标题
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        keywordSearch: '', //关键字
        noticeState: '', //公告状态
        noticeType: '', //公告类型
        tenantGuid: '', //通知公司
        feedbackRequest: '', //反馈要求(1 阅读即可；2 阅读并确认；3 确认并签字)
        isStrongRemind: '', //是否强提醒，Y 是；N 否
        publishDateBegin: '', //发布日期开始时间
        publishDateEnd: '', //发布日期结束时间
      },
      // 阅读情况分页
      readDialog:false,
      innerVisible:false,
      innerUrl:'',
      loading:false,
      page3: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        staffName:'',//人名
        // isRead:'',//已读状态，Y 是；N 否
        isConfirm:'',//确认状态，Y 是；N 否
        isSign:'',//Y 是；N 否
        platformNoticeGuid:'',//公告guid
      },
      // 反馈要求
      feedbackStatus: [
        {
          text: '全部',
          value: '',
        },
        {
          text: '阅读即可',
          value: '1',
        },
        {
          text: '阅读并确认',
          value: '2',
        },
        {
          text: '确认并签字',
          value: '3',
        },
      ],
      // 阅读状态
      readStatus: [
        {
          text: '全部',
          value: '',
        },
        {
          text: '已读',
          value: 'Y',
        },
        {
          text: '未读',
          value: 'N',
        },
      ],
      // 确认状态
      confirmStatus: [
        {
          text: '全部',
          value: '',
        },
        {
          text: '已确认',
          value: 'Y',
        },
        {
          text: '未确认',
          value: 'N',
        },
      ],
      // 签字状态
      signStatus: [
        {
          text: '全部',
          value: '',
        },
        {
          text: '已签字',
          value: 'Y',
        },
        {
          text: '未签字',
          value: 'N',
        },
      ],
      // 公告状态
      noticeStatus: [
        {
          text: '全部',
          value: '',
        },
        {
          text: '待发布',
          value: '1',
        },
        {
          text: '已发布',
          value: '2',
        },
        {
          text: '已撤回',
          value: '3',
        },
        {
          text: '已作废',
          value: '4',
        },
      ],
      readList:[],//阅读情况列表
    };
  },
  filters: {
    readType(val){
      return val === 'Y' ? '已读' : '未读';
    },
    confirmType(val){
      return val === 'Y' ? '已确认' : '未确认';
    },
    feedbackStatusType(val) {
      let objStr = {
        '1': '阅读即可',
        '2': '阅读并确认',
        '3': '确认并签字',
      };
      return objStr[val] || '-';
    },
    noticeStateType(val) {
      let objStr = {
        '1': '待发布',
        '2': '已发布',
        '3': '已撤回',
        '4': '已作废',
      };
      return objStr[val] || '-';
    },
    // 通知公司
    tenantNameFilter(val){
      let str='-'
      if (val.length>1){
        str=val[0]+' 等'+val.length+'家公司'
      }else if(val.length==1){
        str=val[0]
      }
      return str
    }
  },
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 310;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 263;
        this.contentMainHeight = window.innerHeight - 200;
        return;
      }
    },
  },
  created() {
    this.userGuid=JSON.parse(localStorage.userInfo).userGuid
    this.getList(true);//页码=1
    this.getSendTenantList();// 获取公司列表

  },
  beforeRouteEnter(to, from, next) {
    if (from.path === '/addAnnounce') {
      next((vm) => {
        vm.getList();
      });
    } else {
      next();
    }
  },
  methods: {
    //发布公告
    addAdv() {
      this.$router.push({
        path: '/addAnnounce',
        query: {
          productGuid: localStorage.productGuid,
        },
      });
    },
    // 获取公司列表
    getSendTenantList() {
      let self = this;
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-service-and-tenant-list`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.sendTenantList = res.data.data;
            self.sendTenantList.unshift({guid:"everyOne",tenantName:"所有服务人员"})
            
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    // 导出阅读明细
    report(){
      let that = this;
      that.loading = true;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        platformNoticeGuid:this.page3.platformNoticeGuid,
        staffName:this.page3.staffName,
        // isRead:this.page3.isRead,
        isConfirm:this.page3.isConfirm,
        isSign:this.page3.isSign,
      };
      let reqUrl=`/${serverConfig.msConfigureService}/platformNoticeRead/export-read-info`
      that.api.postJson(reqUrl, req).then((res1) => {
      if (res1.data.code == 'S0010') {
        // 数据为空
        that.$message.error(res1.data.msg);
        that.loading = false;
      } else {
        that.api.postJsonD(reqUrl, req).then(res => {
          let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let str=`${this.noticeTitle}_`
          let fileName = str + this.$moment(new Date()).format('YYYYMMDD');
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = fileName;
          link.href = objectUrl;
          link.click();
          that.loading = false;
        });
      }
      });
    }, 
    // 点击查看阅读情况
    readConfig(row){
      this.readDialog=true
      this.page3= {
        pageIndex: 1,
        pageSize: 10,
        staffName:'',//人名
        // isRead:'',//已读状态，Y 是；N 否
        isConfirm:'',//确认状态，Y 是；N 否
        isSign:'',//Y 是；N 否
        platformNoticeGuid:row.guid
      },
      this.feedbackRequest=row.feedbackRequest
      this.noticeTitle=row.noticeTitle
      this.readList=[]
      this.getReadInfo()//获取阅读情况
    },
    // 清空搜索
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        keywordSearch: '', //关键字
        noticeState: '', //公告状态
        noticeType: '', //公告类型
        tenantGuid: '', //通知公司
        feedbackRequest: '', //反馈要求(1 阅读即可；2 阅读并确认；3 确认并签字)
        isStrongRemind: '', //是否强提醒，Y 是；N 否
        publishDateBegin: '', //发布日期开始时间
        publishDateEnd: '', //发布日期结束时间
      };
      this.publishTime=[]
      this.getList(true);
    },
    // 获取平台公告列表
    getList(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      this.page.publishDateBegin = this.publishTime[0]
        ? this.$moment(this.publishTime[0]).format('YYYY-MM-DD 00:00:00')
        : '';
      this.page.publishDateEnd = this.publishTime[1]
        ? this.$moment(this.publishTime[1]).format('YYYY-MM-DD 23:59:59')
        : '';
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msConfigureService}/platformNotice/list`, this.page).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    // 修改公告状态 
    changeState(guid,state) {
      let self = this;
      let str=''
      let objStr = {
        3: '撤回后，服务人员将无法看到此消息，确定操作吗？',
        4: '作废后，系统将不会发送此消息，确定操作吗？',
        1: '即将发布公告，确定操作吗？',
      };
      str=objStr[state]
      this.$confirm(str, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        self.fullscreenLoading = true;
        self.api.put(`/${serverConfig.msConfigureService}/platformNotice/update-state?guid=${guid}&noticeState=${state}`).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.getList()
        } else {
          self.$message.error(res.data.msg);
        }
      });
      })
      
    },
    // 去编辑
    toEdit(item,flg) {
      this.$router.push({
        path: '/addAnnounce',
        query: {
          guid: item.guid,
          isDisabled:flg
        },
      });
    },
    // 去复制
    toCopy(item) {
      this.$router.push({
        path: '/addAnnounce',
        query: {
          guid: item.guid,
          isCopy:true,
        },
      });
    },
    // 删除公告
    delAnnounce(guid) {
      this.$confirm('删除后不可恢复，确定要删除吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.api.postJson(`/${serverConfig.msConfigureService}/platformNotice/del?guid=${guid}`).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message({
              message: '删除成功',
              type: 'success',
            });
            this.getList();//获取列表
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 清空阅读搜索
    emptyReadSearch(){
        this.page3.pageIndex= 1,
        this.page3.staffName=''
        // this.page3.isRead='',//已读状态，Y 是；N 否
        this.page3.isConfirm='',//确认状态，Y 是；N 否
        this.page3.isSign='',//Y 是；N 否
        this.getReadInfo()//获取阅读情况
    },
    // 分页获取阅读信息
    getReadInfo(){
      let that=this
      this.loading = true;
      that.api.postJson(`/${serverConfig.msConfigureService}/platformNoticeRead/list`, that.page3).then((res) => {
        this.loading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let readList = res.data.data.records;
          if(readList && readList.length>0){
            readList.forEach(item=>{
              if(item.signUrl){
                item.signUrl=JSON.parse(item.signUrl)
              }
            })
          }
          that.readList=readList
          that.page3.totalPage = res.data.data.totalPages;
          that.page3.totalRows = res.data.data.totalRows;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 查看图片
    onPreview(file) {
      this.innerUrl=''
      this.innerVisible=true
      this.innerUrl=file.path
      // var fileSuffix = file.fileName ? file.fileName.substring(file.fileName.lastIndexOf('.') + 1) : '';
      // if (fileSuffix === 'png' || fileSuffix === 'jpeg' || fileSuffix === 'jpg' || fileSuffix === 'pdf') {
      //   return window.open(file.path, file.fileName);
      // }
      // window.open('https://view.officeapps.live.com/op/view.aspx?src=' + file.path);
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
    handleSizeChange3(val) {
      this.page3.pageSize = val;
      this.getReadInfo()//获取阅读情况
    },
    handleCurrentChange3(val) {
      this.page3.pageIndex = val;
      this.getReadInfo()//获取阅读情况
    },
  },
};
</script>

<style lang="less" scoped>

.state-class{
  height: 22px;
  width: 48px;
  display: block;
  box-sizing: border-box;
  background: #F2FFF5;
  border: 1px solid rgba(220,250,228,1);
  border-radius: 2px;
  font-size: 12px;
  color: #1BA854;
  letter-spacing: 0;
  line-height: 22px;
  margin: 0 auto;
  }
.state-class-grey{
  height: 22px;
  width: 48px;
  display: block;
  box-sizing: border-box;
  background:  #F5F5F5;
  border: 1px solid rgba(217,217,217,1);
  border-radius: 2px;
  font-size: 12px;
  color: #404040;
  letter-spacing: 0;
  line-height: 22px;
  margin: 0 auto;
  
}
.state-class-org{
  height: 22px;
  width: 48px;
  display: block;
  box-sizing: border-box;
  background: #FFFBF2;
  border: 1px solid rgba(255,241,212,1);;
  border-radius: 2px;
  font-size: 12px;
  color: #FF991C;
  letter-spacing: 0;
  line-height: 22px;
  margin: 0 auto;
  
}
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

.el-range-editor.el-input__inner {
  padding: 0px;
}

/deep/ .el-checkbox__label {
  display: none;
}
/deep/ .el-dialog {
  width:60%
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
.search-area .search-area-div{
  flex-shrink: 0;
  width:72px;
  text-align: right;
  margin-right: 2px;
}
.read-dialog .search-area-div{
  width:60px!important;
}
.ipt-sty{
  flex: 1;
}
.el-col-6 ,.el-col-4{
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
}
.el-col-20{
  display: flex;
  justify-content: flex-start;
  margin-bottom: 12px;
}
.el-col-8{
  display: flex;
  // margin-bottom: 15px;
  justify-content: flex-end;
}
.feedback-box{
  font-size: 14px;
  color: #212121;
  line-height: 24px;
}

/deep/ .el-dialog__body{
  padding: 0 20px ;
}

.read-box /deep/ .el-table {
  font-size: 12px;
  color: #212121;
  
}


.read-box /deep/ .el-table__body-wrapper tr, .content-main-box .el-table__body td.el-table__cell {
  height: 32px;
}

/* .content-main-box .el-table__body-wrapper tr td:first-child {
  border-right: 1px solid #D9D9D9;
} */

.read-box /deep/  .el-table .el-table__cell {
  padding: 0px;
}

.read-box /deep/ .el-table th.el-table__cell {
  background-color: #F2F2F2;
  height: 32px;
  border-right: 1px solid #D9D9D9;
  border-top: 1px solid #D9D9D9;
}

.read-box /deep/ .el-table th.el-table__cell:last-child {
  border-right: none;
}
.read-box /deep/ .el-table th.el-table__cell:nth-last-child(2) {
  border-right: none;
}

.content-main-box /deep/ .el-table td.el-table__cell, .content-main-box .el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid #D9D9D9;
}

</style>
